import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-123e3f5a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-wrapper"
};
const _hoisted_2 = {
  class: "home-list-content"
};
const _hoisted_3 = {
  class: "course-resource"
};
const _hoisted_4 = {
  class: "home-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_BannerList = _resolveComponent("BannerList");

  const _component_Course = _resolveComponent("Course");

  const _component_SpocCourse = _resolveComponent("SpocCourse");

  const _component_VirtualList = _resolveComponent("VirtualList");

  const _component_News = _resolveComponent("News");

  const _component_TeacherList = _resolveComponent("TeacherList");

  const _component_TeacherData = _resolveComponent("TeacherData");

  const _component_Link = _resolveComponent("Link");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Head, {
    menuCode: $data.menuCode,
    onGetUserInfo: $options.getUserInfo,
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    onUserRole: $options.getZhsRole
  }, null, 8, ["menuCode", "onGetUserInfo", "menuInfo", "onUserRole"]), $data.bannerItem && $data.bannerItem.home_open ? (_openBlock(), _createBlock(_component_BannerList, {
    key: 0
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.moocItem && $data.moocItem.home_open ? (_openBlock(), _createBlock(_component_Course, {
    key: 0,
    courseType: 1,
    menu: $data.moocItem,
    userInfo: $data.userInfo,
    zhsRole: $data.zhsRole,
    isTop: $data.bannerItem && $data.bannerItem.home_open,
    class: "course-item"
  }, null, 8, ["menu", "userInfo", "zhsRole", "isTop"])) : _createCommentVNode("", true), $data.spocItem && $data.spocItem.home_open ? (_openBlock(), _createBlock(_component_SpocCourse, {
    key: 1,
    menu: $data.spocItem,
    userInfo: $data.userInfo
  }, null, 8, ["menu", "userInfo"])) : _createCommentVNode("", true), $data.virtualItem && $data.virtualItem.home_open ? (_openBlock(), _createBlock(_component_VirtualList, {
    key: 2,
    menu: $data.virtualItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true)]), $data.newsItem && $data.newsItem.home_open ? (_openBlock(), _createBlock(_component_News, {
    key: 0,
    courseType: 1,
    menu: $data.newsItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), $data.teacherItem && $data.teacherItem.home_open ? (_openBlock(), _createBlock(_component_TeacherList, {
    key: 1,
    menu: $data.teacherItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true)]), $data.dataItem && $data.dataItem.home_open ? (_openBlock(), _createBlock(_component_TeacherData, {
    key: 1,
    menu: $data.dataItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [$data.footerItem && $data.footerItem.home_open ? (_openBlock(), _createBlock(_component_Link, {
    key: 0,
    menu: $data.footerItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), _createVNode(_component_Footer)])])]);
}